import Vue from "vue";
import VueRouter from "vue-router";

// 进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 路由数据
import routes from "./routes";
import util from "@/libs/util.js";
// 状态管理
import store from "@/store/index.js";

// fix vue-router NavigationDuplicated
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch((err) => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  mode: "history",
  // mode: "hash",
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   return { x: 0, y: 0 };
  // },
});

router.beforeEach((to, from, next) => {
  console.log(`router => `)
  console.log(`to => `)
  console.log(to)
  console.log(`from => `)
  console.log(from)
  console.log(`next => `)
  console.log(next)
  console.log(`${from.name} => ${to.name}`)
  // 进度条
  NProgress.start();
  // 保存滚动位置到Vuex
  store.commit('data/SetScrollPosition', {
    name: from.name || 'homePage',
    to: to.name,
    scroll: window.scrollY
  });
  next();
});

router.afterEach((to) => {
  // 进度条
  NProgress.done();
  // 更改标题
  util.title(to.meta.title);
});

export default router;
